import { useDataTableFeatures } from "@/components/data-table/hooks/useDataTableFeatures";
import { useDataTableSettings } from "@/components/data-table/hooks/useDataTableSettings";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useOnlySelectedMode } from "@/components/query-table/hooks/useOnlySelectedMode";
import { dataTableOnlySelectedViewModes } from "@/types/dataTableSettings";
import { useTranslation } from "react-i18next";

export default function QueryTableOnlySelectedMenubarTabs() {
  const { t } = useTranslation();
  const { name } = useDataTableSettings<unknown>();
  const { enableOnlySelectedFilter, enableRowSelection } =
    useDataTableFeatures();
  const enabled = Boolean(enableOnlySelectedFilter && enableRowSelection);
  const { mode, onModeChange } = useOnlySelectedMode({
    tableName: name,
    enabled,
  });

  if (!enabled) return null;

  return (
    <div className="pl-2 shrink-0">
      <Tabs value={mode} onValueChange={onModeChange}>
        <TabsList aria-label={t("table.view.menuAria")} className="h-8">
          <TabsTrigger
            value={dataTableOnlySelectedViewModes.all}
            className="h-7 px-2 text-xs"
          >
            {t("table.view.all")}
          </TabsTrigger>
          <TabsTrigger
            value={dataTableOnlySelectedViewModes.selected}
            className="h-7 px-2 text-xs"
          >
            {t("table.view.selected")}
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  );
}
